import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  /**
   * 获取顾问列表
   */
  getConsultantList(data) {
    return request({
      url: '/business/hospitalAdvisor/list',
      method: 'POST',
      data
    })
  },
  /**
   * 获取顾问二次提交列表
   */
  getConsultantSecModifyList(data) {
    return request({
      url: '/business/hospitalAdvisor/secModifyList',
      method: 'POST',
      data
    })
  },
  /**
   * 添加顾问
   */
  addConsultant(data) {
    return request({
      url: `/business/hospitalAdvisor/admin/add`,
      method: 'POST',
      data
    })
  },
  /**
   * 更新顾问
   */
  updateConsultant(data) {
    return request({
      url: `/business/hospitalAdvisor/update`,
      method: 'POST',
      data
    })
  },
  /**
   * 审核顾问
   */
  auditConsultant(data) {
    return request({
      url: `/business/auditCenter/processAudit`,
      method: 'POST',
      data
    })
  },
  /**
   * 顾问变更状态
   */
  changeConsultantState(data) {
    return request({
      url: `/business/hospitalAdvisor/changeState`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取获取顾问(最新编辑后的)信息
   */
  getConsultant(data) {
    return request({
      url: `/business/hospitalAdvisor/admin/getInfo`,
      method: 'POST',
      data
    })
  },
  // 获取当前顾问审核记录
  getCurrentAdvisorAudit(data) {
    return request({
      url: `/business/auditCenter/processNode`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取顾问审核记录列表
   */
  getHistoryProcessList(data) {
    return request({
      url: `/business/hospitalAdvisor/admin/getProcessPageList`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取顾问新的审核流程记录
   */
  getProcessInfo(data) {
    return request({
      url: `/business/hospitalAdvisor/admin/getProcessInfo`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取驳回列表
   */
  // getReplyList(data) {
  //   return request({
  //     url: '/admin/adminReply/list',
  //     method: 'POST',
  //     data
  //   })
  // },
  /**
   * 获取省公司列表
   */
  getCompany(data) {
    return request({
      url: `/advisor/hospitalAdvisorCompany/list`,
      method: 'POST',
      data
    })
  },
  /**
   * 根据账号信息获取省公司列表
   */
  getCompanyOrganization(data) {
    return request({
      url: `/advisor/hospitalAdvisorCompany/getCompanyOrganization`,
      method: 'POST',
      data
    })
  },
  /**
   * 根据公司获取部门列表
   */
  getDepartmentList(companyCode) {
    return request({
      url: `/advisor/hospitalAdvisorDepartment/getSelectedListByCompanyCode/${companyCode}`,
      method: 'GET'
    })
  },
  /**
   * 根据部门获取子部门列表
   */
  getDepartmentSubList(data) {
    return request({
      url: `/advisor/hospitalAdvisorDepartment/getBranchSelectedList`,
      method: 'POST',
      data
    })
  },
  /**
   * 标记顾问
   */
  addConsultMark(data) {
    return request({
      url: `/advisor/hospitalAdvisor/admin/addMark`,
      method: 'POST',
      data
    })
  },
  /**
   * 查询岗位下对应可选择的部门级别
   */
  getDepartmentLevelList(data) {
    return request({
      url: '/advisor/stationDepartmentRel/getDepartmentLevelList',
      method: 'POST',
      data
    })
  },
  /**
   * 导入记录列表分页查询
   */
  advisorImportRecordList(data) {
    return request({
      url: '/advisor/dataImport/importRecordList',
      method: 'POST',
      data
    })
  },
  /**
   * 导入记录列表分页查询
   */
  advisorImportFailList(data) {
    return request({
      url: '/advisor/dataImport/importFailList',
      method: 'POST',
      data
    })
  },
  /**
   * 查询所有省份
   */
  getProvinceList(data) {
    return request({
      url: '/common/commonDistrict/provinceList',
      method: 'POST',
      data
    })
  },
  /**
   * 查询省公司部门信息树
   */
  // getCompanyDepartmentTree(data) {
  //   return request({
  //     url: '/advisor/hospitalAdvisorDepartment/admin/companyDepartmentTree',
  //     method: 'POST',
  //     data
  //   })
  // },
  /**
   * 关联省份
   */
  relateProvince(data) {
    return request({
      url: '/advisor/hospitalAdvisorDepartment/admin/relateProvince',
      method: 'POST',
      data
    })
  },
  /**
   * 部门列表
   */
  searchDepartmentList(data) {
    return request({
      url: '/advisor/hospitalAdvisorDepartment/admin/departmentList',
      method: 'POST',
      data
    })
  },
  /**
   * 添加部门
   */
  // addDepartment(data) {
  //   return request({
  //     url: '/business/organization/config/addDepartment',
  //     method: 'POST',
  //     data,
  //     privateFlag: true
  //   })
  // },
  /**
   * 修改部门
   */
  // editDepartment(data) {
  //   return request({
  //     url: '/business/organization/config/modifyDepartment',
  //     method: 'POST',
  //     data
  //   })
  // },
  /**
   * 查询可被关联的所有省份列表
  */
  getCompanyProvinceList(data) {
    return request({
      url: '/business/company/provinceList',
      method: 'POST',
      data
    })
  },
  /**
   * 查询可被关联的所有省份列表
  */
  batchUpdateAdvisorDepartment(data) {
    return request({
      url: '/advisor/hospitalAdvisor/admin/batchUpdateAdvisorDepartment',
      method: 'POST',
      data
    })
  },
  // 导出顾问
  exportAdvisor(data) {
    return request({
      url: '/business/hospitalAdvisor/export',
      method: 'POST',
      data
    })
  }
}
